import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

import { FilePicker as BackboneFilePicker } from '@bingads-webui/file-picker';
import { BackboneInstanceWrapper } from '@bingads-webui-react/backbone-instance-wrapper';

import { stringKeys } from '../common/constants';

const filePathIndicatorStyle = {
  border: 'solid 1px',
  borderColor: '#F1F1F1',
  backgroundColor: '#F8F8F8',
  padding: '4px 9px',
  height: '25px',
  width: '260px',
};

const filePickerWrapperContainerStyle = { paddingLeft: '0px' };

// Enhanced filepicker for Customer List
export class CustomerListFilePicker extends React.PureComponent {
  static propTypes = {
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
      parseDecimal: PropTypes.func.isRequired,
    }).isRequired,
    onFileChangedAsync: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    const filePickerOptions = {
      theme: 'default',
      allowedFileExtensions: ['.csv'],
      validateFileExtensionsFailedMessage: '',
      i18n: this.props.i18n,
      isNative: false,
      displayFilePath: 'filename',
    };

    this.filePicker = new BackboneFilePicker(filePickerOptions);

    this.filePicker.on('changed', this.onFileChanged);
    this.filePicker.on('cleared', this.onFileCleared);
    this.filePicker.on('validated', this.onFileValidated);
    this.filePicker.on('error.extension', this.onFileWithInvalidExtension);
    // Won't use the error information container of the backbone file picker
    this.filePicker.viewModel.validationDidFail = () => { };

    this.filePicker.render();
    this.filePicker.$('.file-text').remove();
    this.filePicker.$('.remove-file').remove();
    this.filePicker.$('.error').hide();
    this.filePicker.$('.file-picker-btn').css('float', 'left');
    this.filePicker.$('.file-picker-btn').css('min-width', '100px');

    // Only for test purpose
    if (this.props.testRef) {
      this.props.testRef.current = {
        that: this,
      };
    }
  }

  state = {
    filePath: '',
    isLoading: false,
    fileError: null,
  }

  onFileChanged = (newFilePath) => {
    this.setState({
      fileError: null,
      filePath: newFilePath ? this.extractFilename(newFilePath) : '',
    });
  }

  onFileCleared = () => {
    this.props.onFileChangedAsync(null);
  }

  onFileValidated = () => {
    this.setState({
      isLoading: true,
    });

    return this.props.onFileChangedAsync(this.filePicker.fileObject)
      .then(() => {
        this.setState({
          fileError: null,
        });
      })
      .catch((newFileError) => {
        this.setState({
          fileError: newFileError,
        });
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  }

  onFileWithInvalidExtension = () => {
    this.setState({
      fileError: this.invalidFileExtensionError,
    });
  }

  extractFilename = (filepath) => {
    // Sometimes there can be 'fakepath' in the file path by explorer
    // Workaround is to display file name only
    const filename = filepath.substr(_.max([filepath.lastIndexOf('\\'), filepath.lastIndexOf('/')]) + 1);

    // In case file name is too long
    if (filename.length > 40) {
      return `${filename.substr(0, 17)}......${filename.substr(-17, 17)}`;
    }

    return filename;
  }

  invalidFileExtensionError =
    new Error(stringKeys.invalidFileErrorMessage);

  render() {
    return (
      <div className="customer-list-file-picker">
        <div className="row">
          <div className="file-path-indicator col-sm-4" style={filePathIndicatorStyle}>
            {this.state.filePath}
          </div>
          <div className="col-sm-4" style={filePickerWrapperContainerStyle}>
            <BackboneInstanceWrapper
              instance={this.filePicker}
            />
          </div>
          <div className="loading-indicator col-sm-4">
            {this.state.isLoading ?
              this.props.i18n.getString(stringKeys.fileLoadingStatement) : null}
          </div>
        </div>
        <div className="row">
          <div className="error-indicator error col-sm-8">
            {this.state.fileError ? this.props.i18n.getString(this.state.fileError.message) : null}
          </div>
        </div>
      </div>
    );
  }
}
